import { createIconComponent } from '../../factory/create-icon-component';
export const TrollyIcon = createIconComponent(
  'TrollyIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="9"
      cy="20"
      r="2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle
      cx="17"
      cy="20"
      r="2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M1 1.00006L1.5 1C1.60765 1 1.66147 1 1.7094 1.00154C3.03433 1.04394 4.17437 1.95087 4.51357 3.23234C4.52584 3.2787 4.53794 3.33115 4.56215 3.43604L4.69231 4.00006M4.69231 4.00006L6.14138 10.2794C6.44795 11.6078 6.60123 12.2721 6.96245 12.7675C7.2811 13.2045 7.71196 13.5473 8.20945 13.7595C8.77341 14.0001 9.45509 14.0001 10.8185 14.0001H16.4287C17.7101 14.0001 18.3508 14.0001 18.8913 13.7818C19.3684 13.5891 19.7879 13.277 20.1095 12.8754C20.4739 12.4204 20.658 11.8067 21.0262 10.5793L21.7641 8.11957C22.183 6.72338 22.3924 6.02528 22.241 5.47196C22.1083 4.98737 21.7981 4.57046 21.3721 4.30415C20.8856 4.00006 20.1568 4.00006 18.6991 4.00006H4.69231Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 14H6C4.89543 14 4 14.8954 4 16C4 17.1046 4.89543 18 6 18H21"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
